import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller, useFieldArray } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import PhoneInput from "react-phone-input-2";
import { Button, Input } from "../CustomComponents";
import LoadingButton from "../CustomComponents/LoadingButton";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const AddDriverModal = ({
  handleClose,
  data,
  imagePreview,
  setImagePreview,
  setFinalImage,
  finalImage,
  onSubmit,
  isLoadingSubmit,
  learningMatData,
  control,
  handleSubmit,
  setValue,
  optionData,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "links",
  });
  const addLinks = () => append({ title: "", link: "" });

  const removeLinks = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  useEffect(() => {
    if (data) {
      setValue("username", data.username);
      setValue("firstname", data.firstname);
      setValue("lastname", data.lastname);
      setValue("mobile_no", data.mobile_no);
      setValue("supervisior_id", data.supervisior_id);
      setValue("truck_no", data.truck_no);
      setValue("status", data.status);
    }
  }, [data]);

  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {data ? "Update" : "Add"} Driver
            </p>
            <FaCircleXmark
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <Form className="w-100" onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-3">
              <p className="m-0 fw-bold">Select Supervisor</p>
              <Controller
                control={control}
                name="supervisior_id"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <>
                    <SelectFieldComponent
                      onSelectChange={onChange}
                      value={value} // Pass the value from react-hook-form to maintain the selected value
                      optionsList={optionData} // Pass the filtered options list
                      firstOption={"Select"}
                    />
                  </>
                )}
              />
            </div>
            <div className="mt-3">
              <p className="m-0">Name</p>
              <div className="d-flex align-items-center gap-3 justify-content-between">
                <Controller
                  control={control}
                  name="firstname"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter First Name"
                      value={value}
                      onChange={onChange}
                      //   minLength={4}
                      //   maxLength={4}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="lastname"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="text"
                      placeholder="Enter Last Name"
                      value={value}
                      onChange={onChange}
                      //   minLength={4}
                      //   maxLength={4}
                    />
                  )}
                />
              </div>
            </div>
            <div className="mt-3">
              <p className="m-0">User Name</p>
              <Controller
                control={control}
                name="username"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Input
                    classes="mt-2 mb-3"
                    type="text"
                    placeholder="User Name"
                    disable={data && true}
                    value={value}
                    onChange={onChange}
                    //   minLength={4}
                    //   maxLength={4}
                  />
                )}
              />
            </div>
            <div className="mt-3 mb-3">
              <Controller
                control={control}
                name="mobile_no"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <PhoneInput
                    country={"us"}
                    value={value}
                    disabled={data && true}
                    onChange={onChange}
                    className="phone-input"
                  />
                )}
              />
            </div>
            <div className="mt-3 mb-3">
              <Controller
                control={control}
                name="truck_no"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Input
                    classes="mt-2 mb-3"
                    type="text"
                    placeholder="Track Number"
                    disable={data && true}
                    value={value}
                    onChange={onChange}
                    //   minLength={4}
                    //   maxLength={4}
                  />
                )}
              />
            </div>

            {!data && (
              <>
                <div className="mt-3">
                  <p className="m-0">Password</p>
                  <Controller
                    control={control}
                    name="password"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Password"
                        value={value}
                        onChange={onChange}
                        //   minLength={4}
                        //   maxLength={4}
                      />
                    )}
                  />
                </div>
                <div className="mt-3">
                  <p className="m-0">Confirm Password</p>
                  <Controller
                    control={control}
                    name="confirm_password"
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        classes="mt-2 mb-3"
                        type="text"
                        placeholder="Cnfirm Password"
                        value={value}
                        onChange={onChange}
                        //   minLength={4}
                        //   maxLength={4}
                      />
                    )}
                  />
                </div>
              </>
            )}
            <div className="mt-3 mb-3 is_polular ">
              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <Form.Check
                    className="mt-0"
                    type={"checkbox"}
                    label={`Status`}
                    id={`inline-checkbox`}
                    onChange={onChange}
                    checked={value}
                  />
                )}
              />
            </div>
            <div className={`w-100 ${cssStyles.saveButton}`}>
              <Button
                text={
                  isLoadingSubmit ? <LoadingButton /> : data ? "Update" : "Add"
                }
                classes="fs-6 mb-2 mt-3 mt-auto"
                type="submit"
                disabled={isLoadingSubmit}
              />
            </div>
          </Form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddDriverModal;
